import { Config, vmodule, VueModule } from '@niknevis/vue-modules'
import CoreModule from '@/modules/common/core'
import SharedModule from '@/modules/shared/vue-modules/shared'
import LayoutModule from '@/modules/shared/vue-modules/layout'
import UserModule from '@/modules/shared/vue-modules/user'
import { ZoneModel } from '@/modules/common/zone/models/zone.model'

@vmodule()
export default class AuthModule extends VueModule {
  readonly name = 'AuthModule'

  imports = [
    CoreModule,
    SharedModule,
    LayoutModule,
    UserModule
  ]

  bootstrap() {
    Config.set('userType', ZoneModel.AUTH)
    this.exports.userType = ZoneModel.AUTH
  }
}
